var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasicPlusBadgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1069,
    height: 1069,
    viewBox: "0 0 1069 1069",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 534.421,
    cy: 534.421,
    r: 534.421,
    fill: "#6A24FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.584 299.143C433.584 281.315 440.667 264.216 453.273 251.61C465.88 239.003 482.978 231.921 500.806 231.921H568.028C585.857 231.921 602.955 239.003 615.562 251.61C628.168 264.216 635.25 281.315 635.25 299.143V433.587H769.695C787.523 433.587 804.621 440.669 817.228 453.276C829.834 465.883 836.917 482.981 836.917 500.809V568.031C836.917 585.86 829.834 602.958 817.228 615.564C804.621 628.171 787.523 635.253 769.695 635.253H635.25V769.698C635.25 787.526 628.168 804.624 615.562 817.231C602.955 829.837 585.857 836.92 568.028 836.92H500.806C482.978 836.92 465.88 829.837 453.273 817.231C440.667 804.624 433.584 787.526 433.584 769.698V635.253H299.14C281.312 635.253 264.213 628.171 251.607 615.564C239 602.958 231.918 585.86 231.918 568.031V500.809C231.918 482.981 239 465.883 251.607 453.276C264.213 440.669 281.312 433.587 299.14 433.587H433.584V299.143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicPlusBadgeIcon);
export default __webpack_public_path__ + "static/media/basicPlusBadgeIcon.2adf7b619fea4a4d6b97f7926025d90a.svg";
export { ForwardRef as ReactComponent };